import {defineStore} from "pinia";
import axios from "axios";
import authHeader from "../services/auth-header";
import {useRoute} from "vue-router";

export const useUserStore = defineStore("users", {
    state: () => ({
        page: null,
        itemsPerPage: null,
        sortBy: null,
        search: null,
        userID: null,
        currentUser: null,
    }),
    persist: true,
    actions: {
        async loadUsers(is_for_select=false) {
            try {
                let url = `userprofiles/?`
                if(this.itemsPerPage) {
                    url += `&per_page=${this.itemsPerPage}`
                }
                if(this.sortBy) {
                    const key = this.sortBy[0].key
                    const order = this.sortBy[0].order
                    url += `&sortby=${key}&order=${order}`
                }
                if(this.search) {
                    url += `&search=${this.search}`
                }
                if(is_for_select) {
                    url += `&is_for_select`
                }
                const response = await axios.get(url, {
                    headers: authHeader(),
                });
                const result = response.data;
                console.log("Load...");
                return result;
            } catch (err) {
                console.log(err);
            }
        },
        async loadUser(itemID=null) {
            try {
                if(itemID) {
                    this.userID = itemID
                }
                else {
                    const route = useRoute()
                    this.userID = route.params.id
                }
                const response = await axios.get(`userprofiles/${this.userID}/`, {
                    headers: authHeader(),
                });
                const result = response.data;
                console.log("Load...");
                return result;
            } catch (err) {
                console.log(err);
            }
        },
        async addUser(data) {
            try {
                await axios.post(
                    "userprofiles/", data,
                    {
                        headers: authHeader(),
                    }
                );
                console.log("Added!");
            } catch (err) {
                console.log(err);
            }
        },
        async editUser(data, userID) {
            try {
                await axios.patch(
                    `userprofiles/${userID}/`, data,
                    {
                        headers: authHeader(),
                    }
                );
                console.log("Edited!");
            } catch (err) {
                console.log(err);
            }
        },
        async getCurrentUser() {
            try {
                const response = await axios.get(`currentuser/`, {
                    headers: authHeader(),
                });
                const result = response.data;
                console.log("Load...");
                this.currentUser = result;
                console.log('current user')
                return result;
            } catch (err) {
                console.log(err);
            }
        },
    },
});
